<template>

    <svg version="1.2"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 24 24"
         width="18"
         height="18">
        <g>
            <path xmlns:default="http://www.w3.org/2000/svg" id="female" d="M18.67,13.51c0-0.2-0.06-0.39-0.17-0.55l-2.67-4c-0.37-0.66-1.06-1.08-1.82-1.11h-4  C9.24,7.87,8.55,8.29,8.18,8.96l-2.67,4c-0.11,0.16-0.17,0.35-0.17,0.55c0,0.55,0.45,1,1,1c0.33,0,0.65-0.17,0.83-0.45l2.37-3.55  h0.47v1.37l-2.57,4.28c-0.06,0.1-0.09,0.22-0.09,0.34c0.01,0.37,0.3,0.66,0.67,0.67h2v2.84c0,0.65,0.52,1.17,1.17,1.17l0,0h1.67  c0.64-0.01,1.15-0.53,1.15-1.17v-2.84h2c0.37-0.01,0.66-0.3,0.67-0.67c0-0.12-0.03-0.24-0.09-0.34l-2.58-4.27v-1.38h0.47l2.36,3.55  c0.18,0.28,0.5,0.45,0.83,0.45C18.22,14.51,18.67,14.06,18.67,13.51L18.67,13.51z M13.66,3.51c-0.91-0.91-2.39-0.91-3.3,0  C9.92,3.94,9.67,4.54,9.68,5.16c-0.01,1.29,1.02,2.34,2.31,2.35c0,0,0.01,0,0.01,0c1.29,0,2.33-1.04,2.33-2.33  c0.01-0.62-0.24-1.22-0.68-1.65L13.66,3.51z" style="fill: rgb(18, 18, 18);" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "FemaleSVG"
    }
</script>

<style scoped>

</style>